// extracted by mini-css-extract-plugin
export default {"Icon":"V7SYnfAGUI3lYrktOMdF"};